/**
 * Firm-appealed lines are identified by appealedReason (same as Internal UI /
 * Appealed filter). Stage payloads often omit comment; reason alone is enough.
 * @param {*} lineItem - a single line-item version / row
 * @returns {boolean}
 */
export const hasFirmAppealFields = (lineItem) =>
  Boolean(String(lineItem?.appealedReason ?? "").trim());

/**
 * True if any version of this line was already appealed by the firm.
 * Pass the versions list (detail page `subLineItems`).
 * @param {Array} [subLineItems=[]]
 * @returns {boolean}
 */
export const hasPriorFirmAppeal = (subLineItems = []) =>
  (Array.isArray(subLineItems) ? subLineItems : []).some(hasFirmAppealFields);
